import httpClient from '../utils/httpClient';

const API_URL = '/absence';

export const createAbsence = async (data) => {
  const response = await httpClient.post(API_URL, data);
  return response;
};

export const createAbsenceBatch = async (data) => {
  const response = await httpClient.post(`${API_URL}/batch`, data);
  return response;
};

export const getAllAbsences = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.year) params.append('year', filters.year);
  if (filters.month) params.append('month', filters.month);
  if (filters.employeeId) params.append('employeeId', filters.employeeId);
  const qs = params.toString();
  const url = qs ? `${API_URL}?${qs}` : API_URL;
  const response = await httpClient.get(url);
  return response;
};

export const getAbsencesByEmployee = async (employeeId, filters = {}) => {
  const params = new URLSearchParams();
  if (filters.year) params.append('year', filters.year);
  if (filters.month) params.append('month', filters.month);
  const qs = params.toString();
  const url = qs ? `${API_URL}/employee/${employeeId}?${qs}` : `${API_URL}/employee/${employeeId}`;
  const response = await httpClient.get(url);
  return response;
};

export const getDeductibleDays = async (employeeId, startDate, endDate) => {
  const response = await httpClient.get(
    `${API_URL}/employee/${employeeId}/deductible?startDate=${startDate}&endDate=${endDate}`
  );
  return response;
};

export const updateAbsence = async (id, data) => {
  const response = await httpClient.put(`${API_URL}/${id}`, data);
  return response;
};

export const deleteAbsence = async (id, updatedBy = 1) => {
  const response = await httpClient.delete(`${API_URL}/${id}`, { data: { updatedBy } });
  return response;
};
